<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("new_text.select_reticles_category") }}
    </h4>
    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-24"
    >
      <div class="d-flex-row justify-start md-row-to-col">
        <button
          class="picker_option weapon_cat d-flex-column gap-16"
          v-for="packOption in reticleCategory"
          :key="packOption"
          @click="selectCategory(packOption)"
          :class="[
            selectedCategory === packOption && 'selected',
            hasClassSelected(packOption) && 'red_dot',
          ]"
        >
          <p
            class="t-white medium-l font-family-2 white-space-no"
            style="text-transform: capitalize"
          >
            {{ packOption }}
          </p>
        </button>
      </div>

      <div
        class="d-flex-column justify-start align-start gap-10 armor_type_picker"
      >
        <label class="medium-m font-family-2 t-grey caps">{{
          $t("new_text.select_reticles")
        }}</label>

        <div class="d-flex-row justify-start flex-wrap">
          <button
            v-for="option in reticles"
            class="d-flex-column justify-start align-start width-max-content gap-5 secondary option selected medium-l font-family-2 b-radius-6"
            style="padding: 6px 12px"
            :class="[weaponExists(option) && 'active']"
            @click="selectWeapon(option)"
          >
            {{ option.title }}
            <p class="regular-m t-grey font-family-2">
              {{ getUserCurrencyCode }}{{ price(option.price) }}
            </p>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { calculateCurrency } from "~/calculate/calculatePrice";
const { currentGameSlug } = useGameComposable();
const { getUserCurrencyCode } = useUserStore();
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const reticleCategory = computed(() => {
  const packPrices = gameStore.getGamePack?.prices || [];
  if (packPrices.length > 0) {
    const uniqueDescriptions = [
      ...new Set(packPrices.map((item) => item.slabs)),
    ];
    return uniqueDescriptions;
  }
  return [];
});
const selectedCategory = ref("holo");

const selectCategory = (cat) => {
  selectedCategory.value = cat;
};

const reticles = computed(() => {
  const packPrices = gameStore.getGamePack?.prices || [];

  const wps = packPrices.filter(
    (item) => item.slabs === selectedCategory.value
  );
  if (wps.length > 0) {
    return wps;
  }
  return [];
});

const price = (cp) => {
  return parseFloat(calculateCurrency(cp)).toFixed(2);
};

const weaponExists = (option) => {
  if (checkoutStore.getDetails?.items?.includes(option.id)) return true;
  return false;
};

const hasClassSelected = (classtitle) => {
  const selected = checkoutStore.getDetails?.items || [];
  if (!selected) return false;

  const packPrices = gameStore.getGamePack?.prices || [];
  const classedReticles = packPrices.filter(
    (item) => item.slabs === classtitle
  );
  if (!classedReticles.length) return false;

  const hasWeapon = classedReticles?.some((wp) => selected.includes(wp.id));

  return hasWeapon;
};
const selectWeapon = (option) => {
  const selected = checkoutStore.getDetails?.items || [];
  if (weaponExists(option)) {
    const otherItems = selected?.filter((sel) => sel !== option.id);
    if (otherItems.length <= 0) return;
    checkoutStore.setDetails({
      items: [...otherItems],
    });
  } else {
    checkoutStore.setDetails({
      items: [...selected, option.id],
    });
  }
};
</script>
